import { Component, OnInit } from '@angular/core';
import {InfoApiService} from '../../../services/rest-api/info.api.service';
import {Router} from '@angular/router';
import {StorageService} from '../../../services/rest-api/storage.service';
import {SeoService} from '../../../services/seo/seo.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ValidationMessages} from './validation-messages';
import {environment} from '../../../../environments/environment';
import {AuthService} from '../../../services/rest-api/auth.api.service';
import {HssResponse} from '../../../services/rest-api/HssResponse';
import {HssErrorResponse} from '../../../services/rest-api/HssErrorResponse';
import {HttpEventType} from '@angular/common/http';
import {NotifyxService} from '../../../services/notify/notifyx.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  contactForm: FormGroup | any;
  facultyData: any[] = [];
  validationMessages = ValidationMessages.messages();
  isLoading = false;

  constructor(private _info: InfoApiService,
              private router: Router,
              private storage: StorageService,
              private seo: SeoService,
              private _formBuilder: FormBuilder,
              private _authService: AuthService,
              private _notify: NotifyxService) {}

  createContactForm(): FormGroup {
    return this.contactForm = this._formBuilder.group({
        your_name: ['',[Validators.required]],
        email: ['',[Validators.required]],
        message: ['',[Validators.required]],
      }
    );
  }

  ngOnInit(): void {
    const localFacultydata = this.storage.getData('facultyData');
    this.facultyData = localFacultydata ? JSON.parse(localFacultydata): [];

    this.seo.setMeta('Contact Faculty of Humanities & Social Sciences',
      'contact, phone number, email of Humanities & Social Sciences University of Ruhuna')
    this.contactForm = this.createContactForm();
  }

  emailInformation() {
    this.isLoading = true;
    const contact_email =  environment.contact_email;
    const data = this.contactForm.getRawValue();

    const formData = new FormData();
    formData.append('your_name', data.your_name);
    formData.append('email', data.email);
    formData.append('message', data.message);
    formData.append('contact_email', contact_email);

    this._authService.contact(formData).subscribe(
      (response: any | HssResponse<any>) => {
        if (response.type !== HttpEventType.UploadProgress) {
          if (response.isSuccess) {

            // Stop loader
            this.isLoading = false;

            // Show the success message
            if(response.message === "EMAIL_SEND_OK"){
              const msg = "Thank you for your email, we will contact you soon"
              this._notify.customAlert('Success', msg, 'success');
            }
          }
        }
      },
      (error: HssErrorResponse<any>) => {
        // Stop loader
        this.isLoading = false;

        // Show the failed message
        this._notify.customAlert('Error', error.message, 'error');
      }
    );
  }
}
